import cn from 'classnames';
import { useState } from 'react';

import { Button, FormControl, Space, TextInput, Typography } from '@sravni/react-design-system';
import { useBoolean, useIsMobile } from '@sravni/react-utils';

import { useIsSubscribing } from '../../hooks/users';
import { validateEmail } from '../../utils/validation';

import styles from './subscription-form.module.scss';

interface ISubscriptionForm {
  userEmail?: string;
  isEmailEditable: boolean;
  onSubscribe: (email?: string) => void;
}

export const SubscriptionForm: React.FC<ISubscriptionForm> = ({ userEmail, onSubscribe, isEmailEditable }) => {
  const isMobile = useIsMobile();
  const isSubscribing = useIsSubscribing();

  const [currentEmail, setCurrentEmail] = useState(userEmail || '');
  const [invalidEmail, setInvalidEmail] = useBoolean(false);

  const handleChangeEmail = (e) => {
    const value = e.target.value;
    setCurrentEmail(value);
    setInvalidEmail.off();
  };

  const submitSubscription = () => {
    const isValid = validateEmail(currentEmail);

    if (isValid) onSubscribe(currentEmail);
    else setInvalidEmail.on();
  };

  return (
    <>
      <div className={styles.text}>
        <Typography.Heading level={1} as={'h1'}>
          Не забудьте
          <br />
          полезное письмо!
        </Typography.Heading>
        <Typography.Text className={cn('article-body', isMobile ? 'h-mt-8' : 'h-mt-16')}>
          {isMobile ? (
            <>
              Подпишитесь на рассылку Сравни — актуальная информация из{'\u00A0'}мира финансов будет всегда под
              {'\u00A0'}рукой
            </>
          ) : (
            <>
              Подпишитесь на рассылку Сравни — актуальная информация из{'\u00A0'}мира финансов будет всегда с{'\u00A0'}
              вами
            </>
          )}
        </Typography.Text>
      </div>
      <img src={require('../../../public/news-assets/subscription.svg')} alt={''} className={styles.picture} />
      <Space size={8} className={!isMobile && 'h-mt-32'} direction={isMobile ? 'vertical' : 'horizontal'}>
        <FormControl invalid={invalidEmail}>
          <TextInput
            className={styles.emailInput}
            placeholder={'Email'}
            value={currentEmail}
            onChange={handleChangeEmail}
            disabled={!isEmailEditable}
            autoFocus={!Boolean(userEmail)}
          />
          {invalidEmail && <FormControl.HelperText>Неверный формат email</FormControl.HelperText>}
        </FormControl>
        <Button
          variant={'primary'}
          color={'gray'}
          size={60}
          block={isMobile}
          className={styles.button}
          onClick={submitSubscription}
          disabled={isSubscribing}
          name={'Подписаться'}
        >
          Подписаться
        </Button>
      </Space>
      <Typography.Text size={12} className={'h-mt-12'}>
        Нажимая на кнопку подписаться, вы соглашаетесь с{' '}
        <Typography.Link
          href={'https://www.sravni.ru/promo/soglasie-na-obrabotku-personalnyh-dannyh/'}
          target={'_blank'}
        >
          правилами обработки информации
        </Typography.Link>
      </Typography.Text>
    </>
  );
};
